var e={label:"Carousel",nextArrowLabel:"Next slide",prevArrowLabel:"Previous slide",slide:"Slide"};export{e as simpleCarouselTranslations};
